module.exports = __webpack_public_path__ + "static/media/bussitunnus.f8bf0a49.png";